export const ASYNC_STORAGE_KEY_NEWS_CHECKED_DATE = "newsChecked"
